var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Features',{staticClass:"facilities-features",attrs:{"value":_vm.features,"align":"center","background":"transparent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }